/**
 * Common functions
 */
export default {
  _debounce (func, delay) {
    let debounceTimer
    return function () {
      const context = this
      const args = arguments
      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(() => func.apply(context, args), delay)
    }
  },
  calculateTop (id, listData) {
    if(listData.length<5) return false
    return (
      listData.map(function (x) {
      return x.id
    }).indexOf(id) > listData.length-4)
  },

  enableAttach(totalItem) {
    let attach = true
    if (totalItem < 5) attach = false;
    return attach
  },
}
